module.exports = __webpack_public_path__ + "src/app/images/brand-photo-1.jpg?a68dee31ee2ddaf00eb823a4219a9a7b";